import React, { useEffect } from 'react';
import { FEATURED_STRATEGIES, FEATURED_STRATEGIES_STORAGE_KEY } from '../../constants/FeaturedStrategies';
import FeaturedStrategiesModal from './FeaturedStrategiesModal';

interface FeaturedStrategiesPageProps {
  isOpen: boolean;
  onClose: () => void;
}

const FeaturedStrategiesPage: React.FC<FeaturedStrategiesPageProps> = ({ isOpen, onClose }) => {
  useEffect(() => {
    // Initialize featured strategies in localStorage if they don't exist
    if (!localStorage.getItem(FEATURED_STRATEGIES_STORAGE_KEY)) {
      localStorage.setItem(FEATURED_STRATEGIES_STORAGE_KEY, JSON.stringify(FEATURED_STRATEGIES));
    }
  }, []);

  return (
    <FeaturedStrategiesModal
      isOpen={isOpen}
      onClose={onClose}
      strategies={FEATURED_STRATEGIES}
    />
  );
};

export default FeaturedStrategiesPage;